import React from 'react';
import Box from '@material-ui/core/Box';

const BADGE_PX = 18;

/**
 * Freemium badge for Cupones nav: circle #F9D783 + crown (SVG asset).
 */
const FreemiumCouponNavBadge = ({ style: outerStyle }) => (
    <Box
        component="span"
        aria-hidden
        style={{
            position: 'absolute',
            top: -9,
            right: -3,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 0,
            filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.15))',
            ...outerStyle,
        }}
    >
        <svg
            width={BADGE_PX}
            height={BADGE_PX}
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ display: 'block' }}
        >
            <g transform="translate(40 40) scale(0.9) translate(-40 -40)">
                <path
                    d="M40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0Z"
                    fill="#F9D783"
                />
                <path
                    d="M40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40C0 17.9086 17.9086 0 40 0Z"
                    fill="none"
                    stroke="#E5E7EB"
                    strokeWidth="1"
                />
            </g>
            <g transform="translate(40 40) scale(1.07) translate(-40 -40)">
                <path
                    d="M28.3333 46.668L25 31.668L34.1667 40.0013L40 26.668L45.8333 40.0013L55 31.668L51.6667 46.668H28.3333ZM32.8333 43.3346H47.1667L48.6667 36.0013L43.3333 40.0013L40 31.668L36.6667 40.0013L31.3333 36.0013L32.8333 43.3346Z"
                    fill="#1E1E1E"
                />
            </g>
        </svg>
    </Box>
);

export default FreemiumCouponNavBadge;
